"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _paulCorePackage = require("paul-core-package");
var _reactTransitionGroup = require("react-transition-group");
var _reactRedux = require("react-redux");
var _FlushingPanelModule = _interopRequireDefault(require("../../styles/components/Flushing/FlushingPanel.module.css"));
var _StepOne = _interopRequireDefault(require("./StepOne"));
var _StepTwo = _interopRequireDefault(require("./StepTwo"));
var _StepOfPreparation = _interopRequireDefault(require("./StepOfPreparation"));
var _selectors = require("../../redux/selectors");
var _hooks = require("../../hooks");
var _function = require("../../utils/function");
var _actions = require("../../redux/actions");
var _StepError = _interopRequireDefault(require("./StepError"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const FlushingPanel = _ref => {
  let {
    className,
    thingPDIDDevice
  } = _ref;
  const timer = (0, _react.useRef)(null);
  const timerError = (0, _react.useRef)(null);
  const dispatch = (0, _reactRedux.useDispatch)();
  /** step: -1 - error; 0 - identify step;  1 - start; 2 - flushing.  */
  const {
    step
  } = (0, _reactRedux.useSelector)(store => (0, _selectors.selectActiveStepById)({
    store,
    thingPDIDDevice
  }));
  const {
    value: duration
  } = (0, _hooks.useGetValueByRegDeviceId)({
    thingPDIDDevice,
    regular: _paulCorePackage.constants.regularsByDisplayNameId.durationRegex
  });
  const {
    value: cV
  } = (0, _hooks.useGetValueByRegDeviceId)({
    thingPDIDDevice,
    regular: _paulCorePackage.constants.regularsByDisplayNameId.smartValve.currentValue
  });

  /** Determining active step */
  (0, _paulCorePackage.usePreviousEffect)(_ref2 => {
    let [prevCV, _, prevThingPDIDDevice] = _ref2;
    if (prevThingPDIDDevice !== thingPDIDDevice) prevCV = null;
    /** If we had error */
    if (step !== -1) {
      const stepInfo = (0, _function.getActiveFlushingStep)({
        cV: +cV,
        prevCV: +prevCV,
        duration: +duration
      });
      // console.log('step update', stepInfo?.step, stepInfo?.process, cV, prevCV, duration, moment().format('hh:mm:ss'))

      /** If we can't to determinate in 30 sec - open start step */
      if (stepInfo.step < 1) {
        if (timerError.current) clearTimeout(timerError.current);
        timerError.current = setTimeout(() => {
          /** If device still have cV 0 and duration greater than 0 - show error */
          if (+duration > 0 && cV < 5 && (!prevCV || prevCV < 5)) {
            dispatch((0, _actions.setFlushingStep)({
              thingPDIDDevice,
              step: -1
            }));
          } else {
            dispatch((0, _actions.setFlushingStep)({
              thingPDIDDevice,
              step: 1
            }));
          }
        }, 30000);
      } else if (timerError.current) clearTimeout(timerError.current);

      /** If at any stage the data has not arrived in 50 sec - we display an error */
      if (stepInfo.step > 1) {
        if (timer.current) clearTimeout(timer.current);
        timer.current = setTimeout(() => {
          dispatch((0, _actions.setFlushingStep)({
            thingPDIDDevice,
            step: -1
          }));
        }, 50000);
      } else if (timer.current) clearTimeout(timer.current);
      if (stepInfo !== null && stepInfo !== void 0 && stepInfo.step) {
        dispatch((0, _actions.setFlushingStep)({
          thingPDIDDevice,
          step: stepInfo === null || stepInfo === void 0 ? void 0 : stepInfo.step,
          process: stepInfo.process || null
        }));
      }
    }
  }, [cV, duration, thingPDIDDevice, dispatch, step]);
  (0, _react.useEffect)(() => () => {
    if (timer.current) clearTimeout(timer.current);
    if (timerError.current) clearTimeout(timerError.current);
  }, []);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "position-relative ".concat(_FlushingPanelModule.default.box_wrap, " ").concat(className || '')
  }, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.SwitchTransition, {
    mode: "out-in"
  }, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
    key: step,
    timeout: 1500,
    addEndListener: (node, done) => node.addEventListener('transitionend', done, false),
    classNames: "fade-card fade"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "transition-box flex-center h-100 w-100"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "flex-column flex-center text-center flex-between h-100 w-100"
  }, step === -1 && /*#__PURE__*/_react.default.createElement(_StepError.default, {
    thingPDIDDevice: thingPDIDDevice
  }), step === 0 && /*#__PURE__*/_react.default.createElement(_StepOfPreparation.default, null), step === 1 && /*#__PURE__*/_react.default.createElement(_StepOne.default, {
    thingPDIDDevice: thingPDIDDevice
  }), step === 2 && /*#__PURE__*/_react.default.createElement(_StepTwo.default, {
    thingPDIDDevice: thingPDIDDevice
  })))))), [step, thingPDIDDevice, className]);
};
var _default = exports.default = FlushingPanel;